@if (loading()) {
  <div class="ts-activity__loading">
    <mat-spinner diameter="24" />
  </div>
} @else if (loadError()) {
  <p class="ts-activity__hint ts-activity__hint--error" role="alert">
    {{ 'testSteps.form.activity.loadError' | translate }}
  </p>
} @else if (items().length === 0) {
  <p class="ts-activity__hint">{{ 'testSteps.form.activity.empty' | translate }}</p>
} @else {
  <ul class="ts-activity__list">
    @for (item of items(); track item.id) {
      <li class="ts-activity__item">
        <span class="ts-activity__icon" aria-hidden="true">
          <mat-icon>{{ item.icon }}</mat-icon>
        </span>
        <div class="ts-activity__body">
          <div class="ts-activity__title">{{ item.titleKey | translate }}</div>
          <div class="ts-activity__meta">
            <span class="ts-activity__author">{{ item.createdByName || ('common.unknownUser' | translate) }}</span>
            <span aria-hidden="true">·</span>
            <time class="ts-activity__date" [attr.datetime]="item.createdAt">{{ item.createdAt | date: 'short' }}</time>
          </div>
        </div>
      </li>
    }
  </ul>
}
